import { POST } from '../crud';

const populateObjects = async (auth) =>  {
	let next = null;

	while (true) {
		try {
			const resp = await POST(`objects/populate${next ? `?page=${encodeURIComponent(next)}` : ''}`, {
				config: {
        			auth: {
        				username: auth.email,
        				password: auth.password,
        			}
				}
			});
			next = resp.next;

			if (!next) break;
		} catch (e){
			break;
		}
	}
}

const poulateDeletedObjects = async (auth) => {
	let next = null;

	while (true) {
		try {
			const resp = await POST(`deletedobjects/populate${next ? `?page=${encodeURIComponent(next)}` : ''}`, {
				config: {
        			auth: {
        				username: auth.email,
        				password: auth.password,
        			}
				}
			});
			next = resp.next;

			if (!next) break;
		} catch (e){
			break;
		}
	}
}

const populate = async (auth) => {
	try {
		await Promise.all([populateObjects(auth), poulateDeletedObjects(auth)]);
	} catch (e) {

		console.log(e);
		alert('WAIT');
	}
};

export default populate;